import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/registrationInfo",
  }, // 当检测到无效路由时重定向到填写流动人口信息
  {
    path: "/registrationInfo",
    name: "registrationInfo",
    component: () => import("../views/registrationInfo.vue"),
  }, // 填写流动人口信息
  {
    path: "/selectHousing",
    name: "selectHousing",
    component: () => import("../views/selectHousing.vue"),
  }, // 选择居住小区
  {
    path: "/pictureInfo",
    name: "pictureInfo",
    component: () => import("../views/pictureInfo.vue"),
  }, // 上传正面照片信息
  {
    path: "/enrolled",
    name: "enrolled",
    component: () => import("../views/enrolled.vue"),
  }, // 登记完成
];

const router = new VueRouter({
  routes,
});

export default router;
